<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    watch: {
      '$route': (to, from) => {
        document.title = `${to.meta.title} | VITC TestWatcher` || 'VITC TestWatcher'
      }
    }    
  }
</script>

<style lang="scss">
#app {
  font-family: "Lato", sans-serif;

  .uppercase {
    text-transform: uppercase;
  }

  .text-larger {
    font-size: 1.1em;
  }

  .text-bold {
    font-weight: bold;
  }

  .is-primary {
    color: #093;
  }

  input[type="text"].form-control,
  input[type="email"].form-control,
  select {
    border-color: rgb(123, 192, 146);
    background: rgb(241, 252, 244);
  }

  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 153, 51, 0.25);
    border-color: #093;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #093;
    background-color: #093;
  }
}
</style>
